<script setup lang="ts">
  import BulletPoint from '../../tips/BulletPoint.vue';
</script>

<template>
  <div>
    <p><BulletPoint />(vazio).pdf (nome obrigatório)</p>
    <p><BulletPoint />Relatório.zip (formato incorreto)</p>
    <p><BulletPoint />(DE) Contrato.txt (adição do "DE")</p>
  </div>
</template>
